import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEGeoInformaticsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Geo Informatics Engineering",
    shortName: "B.E. Geo Informatics",
    duration: "4 years",
    description: "Specialized engineering program combining geography, surveying, and information technology for spatial data management",
    overview: "Bachelor of Engineering in Geo Informatics Engineering (B.E. Geo Informatics) is a 4-year undergraduate program that integrates geospatial technologies, Geographic Information Systems (GIS), Remote Sensing, and surveying techniques. This course prepares students to collect, analyze, and manage spatial data for various applications in urban planning, natural resource management, and environmental monitoring.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in geography and technology"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Computer Programming",
          "Basic Surveying"
        ]
      },
      {
        year: 2,
        subjects: [
          "Advanced Surveying",
          "Cartography",
          "Database Management Systems",
          "Statistics",
          "Photogrammetry",
          "Land Records and Law"
        ]
      },
      {
        year: 3,
        subjects: [
          "Geographic Information Systems",
          "Remote Sensing",
          "GPS and GNSS",
          "Digital Image Processing",
          "Spatial Analysis",
          "Web GIS Development"
        ]
      },
      {
        year: 4,
        subjects: [
          "LiDAR and 3D Mapping",
          "Urban Planning Applications",
          "Natural Resource Management",
          "Disaster Management GIS",
          "Project Work",
          "Industry Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "GIS Specialist",
        "Remote Sensing Analyst",
        "Geospatial Developer",
        "Survey Engineer",
        "Urban Planner",
        "Cartographer",
        "Spatial Data Analyst",
        "Geoinformatics Consultant"
      ],
      industries: [
        "Survey and Mapping Companies",
        "Urban Planning Agencies",
        "Government Survey Departments",
        "Environmental Consulting",
        "Oil and Gas Companies",
        "Telecom Companies",
        "Agriculture and Forestry",
        "Defense and Security"
      ],
      averageSalary: "₹4-7 LPA (Fresher), ₹10-22 LPA (Experienced)",
      topRecruiters: [
        "Survey of India",
        "ISRO, NRSC",
        "Esri India",
        "TCS, Infosys (GIS Division)",
        "L&T, Shapoorji Pallonji",
        "RMSI, Genesys International"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "Kongu Engineering College",
        location: "Erode",
        fees: "₹3,00,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "K.S. Rangasamy College of Technology",
        location: "Tiruchengode",
        fees: "₹2,80,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "Bannari Amman Institute of Technology",
        location: "Sathyamangalam",
        fees: "₹3,50,000",
        ranking: "NAAC A Grade"
      }
    ],

    skills: [
      "GIS Software (ArcGIS, QGIS)",
      "Remote Sensing Applications",
      "GPS and Survey Techniques",
      "Spatial Database Management",
      "Programming (Python, R)",
      "Cartographic Design",
      "Image Processing",
      "Web Mapping Technologies",
      "Spatial Analysis",
      "Project Management"
    ],

    futureScope: "Excellent growth potential with increasing digitization, smart city projects, precision agriculture, and geospatial applications in various sectors including autonomous vehicles and location-based services.",

    faqs: [
      {
        question: "What is the scope of Geo Informatics Engineering?",
        answer: "Very broad scope including urban planning, environmental monitoring, agriculture, disaster management, navigation, and emerging areas like autonomous vehicles and IoT."
      },
      {
        question: "Do I need to be good at geography?",
        answer: "Basic geography knowledge helps, but the focus is more on technology and spatial analysis rather than traditional geography."
      },
      {
        question: "Are there opportunities in government jobs?",
        answer: "Yes, excellent opportunities in Survey of India, State Survey Departments, Urban Development Authorities, and various ministries."
      },
      {
        question: "Can I work in IT companies?",
        answer: "Absolutely! Many IT companies have dedicated GIS divisions and there's growing demand for location-based services and spatial applications."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEGeoInformaticsCoursePage;
